import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getVideosFromFBStorage, uploadAndRetrieveFiles } from "../functions/firebase/storage";
import { deleteObject, getDownloadURL, getStorage, ref } from "firebase/storage";
import { collection, deleteDoc, doc, getDocs, query, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../databases/firebase";

const initialState = { allVideos: {}, isLoading: false, message: "" };

export const addVideoToDBThunk = createAsyncThunk(
   'allVideosSlice/addToDB',
   async (payload, { rejectWithValue }) => {
      try {
         const uploadedVideo = await uploadAndRetrieveFiles(payload._videoID, payload.link, "video");
         const link = await getDownloadURL(uploadedVideo.ref);

         return { ...payload, link };
      } catch (err) {
         console.error({ origin: 'addVideoToDBThunk.', err, errCode: err.code, errValue: err.value, rejectWithValue: rejectWithValue('Reject With Value Error.') });
         rejectWithValue('Reject with value error trying to upload video from computer!!!');
      }
   }
);

export const addVideoToFS = createAsyncThunk(
   'allVideosSlice/addVideoToFS',
   async (payload, { rejectWithValue }) => {
      try {
         if (payload.source === "computer") {
            const uploadToFBStorage = await uploadAndRetrieveFiles(payload._videoID, payload.link, "video");
            const link = await getDownloadURL(uploadToFBStorage.ref);
            payload = { ...payload, link };
         }

         const addVideoToFirestore = await setDoc(doc(db, "internet-idol-faceoff", "Videos", "allVideos", payload._videoID), { ...payload });

         return { ...payload };
      } catch (err) {
         console.error({ origin: "addVideoToFS createAsyncThunk", err, errCode: err.code, errMessage: err.message, payload, rejectWithValue: rejectWithValue("Reject with value error!!! => " + payload) });
      }
   }
);

export const updateFSvideoData = createAsyncThunk(
   'allVideosSlice/updateFSvideosData',
   async (payload, { dispatch, rejectWithValue, getState }) => {
      const { _videoID, _newKey, _newValue } = payload;

      try {
         const videoRef = doc(db, "internet-idol-faceoff", "Videos", "allVideos", _videoID);
         const updateVideoInFS = await updateDoc(videoRef, { [_newKey]: { ..._newValue } }).then((_videoID, _newValue) => {
            console.log("===== SUCCESS!!! =====")
            console.log(`Updated ${_videoID} from the payload ${JSON.stringify(payload)} into firestore with new value: `, _newValue);
            console.log("======================\n")
         }).catch(error => console.error({ message: "Error inside FSVideoData Thunk", error, errorCode: error.code, errorMessage: error.message }));
         
         return payload;
      } catch (error) {
         console.error({ origin: "updateFSvideoData", error, errorCode: error.code, errorMessage: error.message });
      }
   }
);

export const updateReduxWithFSvideosData = createAsyncThunk(
   'allVideosSlice/updateReduxWithFSvideos',
   async (payload, { dispatch, rejectWithValue }) => {
      const allVideos = {};
      try {
         const videosQuery = query(collection(db, "internet-idol-faceoff", "Videos", "allVideos"));
         const videosQuerySnapshot = await getDocs(videosQuery);
         videosQuerySnapshot.forEach(doc => {
            allVideos[doc.id] = { ...doc.data() };
         })

         return allVideos;
      } catch (err) {
         console.error({ origin: "updateReduxWithFSvideosData", err, errCode: err.code, errMessage: err.message, rejectWithValue: rejectWithValue({ origin: 'updateReduxWithFSVideosData', message: 'reject with value error!!!' }) });
         rejectWithValue({ origin: 'updateReduxWithFSVideosData', message: 'reject with value error!!!' });
      }
   }
);

export const removeVideoFromFSandRedux = createAsyncThunk(
   "allVideosSlice/removeVideoFromFSandRedux",
   async (payload, { rejectWithValue, dispatch }) => {
      try {
         const deleteVideoFromFSallVideos = await deleteDoc(doc(db, "internet-idol-faceoff", "Videos", "allVideos", payload._videoID));
         if (payload.source === "computer") {
            const storage = getStorage();
            const videoRef = ref(storage, `internet-idol-faceoff/videos/${payload._videoID}`);
            const deleteVideoFromStorage = await deleteObject(videoRef);
         }
         await dispatch(removeVideo({ ...payload }));
      } catch (error) {
         console.error({
            origin: "removeVideoFromFSandRedux",
            payload,
            error,
            errorCode: error.code,
            errorMessage: error.message,
            rejectWithValue: rejectWithValue("rejectWithValue error on removeVideoFromFSandRedux!!!")
         });
      }
   }
);

const allVideosSlice = createSlice({
   name: 'allVideos',
   initialState,
   reducers: {
      addNewVideo: (state, { payload }) => {
         return { ...state, allVideos: { ...state.allVideos, [payload._videoID]: { ...payload } } };
      },
      removeVideo: (state, { payload }) => {
         const { [payload._videoID]: removedVideo, ...rest } = state.allVideos;

         return { ...state, allVideos: { ...rest } };
      },
      updateVideo: (state, { payload }) => {
         //payload = {_videoID, newKey, newValue};

         return { ...state, allVideos: { ...state.allVideos, [payload._videoID]: { ...state.allVideos[payload._videoID], [payload._newKey]: { ...payload._newValue } } } }
      }
   },
   extraReducers: {
      [addVideoToDBThunk.pending]: state => {
         state.isLoading = true;
         state.message = "Please wait while we add new video to DB.";
         console.log({ loadingStatus: state.isLoading, message: state.message });
      },
      [addVideoToDBThunk.fulfilled]: (state, { payload }) => {
         state.isLoading = false;
         state.message = "";
         state.allVideos = { ...state.allVideos, [payload._videoID]: { ...payload } };
      },
      [addVideoToDBThunk.rejected]: (state, { payload, error }) => {
         state.isLoading = false;
         state.message = "";
         
         if (error) {
            console.error({ error, errorCode: error.code, errorMessage: error.message, payload });
         } else {
            console.error({ message: "Error trying to add video payload to DB.", payload });
         }
      },
      [addVideoToFS.pending]: (state, { payload }) => {
         state.isLoading = true;
         state.message = `Please wait while we upload the following video: ${JSON.stringify(payload)}...`
         console.log({ loadingStatus: state.isLoading, message: state.message });
      },
      [addVideoToFS.fulfilled]: (state, { payload }) => {
         state.isLoading = false;
         state.message = "";
         state.allVideos = { ...state.allVideos, [payload._videoID]: { ...payload } };
         console.log({ origin: "addVideoToFS.fulfilled", message: "SUCCESS!!!", state, payload });
      },
      [addVideoToFS.rejected]: (state, { error, rejectWithValue, payload }) => {
         if (error || rejectWithValue) {
            console.error({ error, errorCode: error.code, errorMessage: error.message, rejectWithValue: rejectWithValue('rejectWithValue inside addVideoToFS.rejectd'), payload });
         } else {
            console.error({ origin: "addVideoToFS.rejected", payload, message: "ERROR UPLOADING VIDEO!!!" });
         }
      },
      [updateFSvideoData.pending]: state => {
         state.isLoading = true;
         state.message = "Please wait while we make the appropriate changes to FS video database...";
         console.log({ isLoading: state.isLoading, message: state.message });
      },
      [updateFSvideoData.fulfilled]: (state, { payload }) => {
         state.isLoading = false;
         state.message = "";

         const { _videoID, _newKey, _newValue } = payload;

         state.allVideos = { ...state.allVideos, [_videoID]: { ...state.allVideos[_videoID], [_newKey]: { ..._newValue } } };
      },
      [updateFSvideoData.rejected]: (state, { error, rejectWithValue, payload }) => {
         state.isLoading = false;
         state.message = "";

         if (error || rejectWithValue) {
            console.error({ origin: "updateFSvideoData.rejected", error, errorCode: error.code, errorMessage: error.message, rejectWithValue: rejectWithValue(`Reject with value error!!!`, payload), payload });
         } else {
            console.error({origin: "updateFSvideoData.rejected", message: "Oops... something went wrong trying to update the new data in the video.", payload})
         }
      },
      [updateReduxWithFSvideosData.pending]: state => {
         state.isLoading = true;
         state.message = "Please wait as we transfer all videos from Firebase to Redux...";
         console.log({ isLoading: state.isLoading, message: state.message });
      },
      [updateReduxWithFSvideosData.fulfilled]: (state, { payload }) => {
         state.isLoading = false;
         state.message = "";
         state.allVideos = { ...payload };
      },
      [updateReduxWithFSvideosData.rejected]: (state, { error, rejectWithValue, payload }) => {
         state.isLoading = false;
         state.message = "";
         if (error || rejectWithValue) {
            console.error({ error, errorCode: error.code, errorMessage: error.message, rejectWithValue: rejectWithValue('rejectWithValue error inside updateReduxWithFSvideosData'), payload });
         } else {
            console.error({ message: "Oops... something went wrong while trying to upload videos from Firebase to Redux.", payload });
         }
      },
      [removeVideoFromFSandRedux.pending]: (state, { payload }) => {
         state.isLoading = true;
         state.message = `Please wait while we delete ${payload}.`;
         console.log({ isLoading: state.isLoading, message: state.message });
      },
      [removeVideoFromFSandRedux.fulfilled]: (state, { payload }) => {
         state.isLoading = false;
         state.message = "";
         console.log(`Successfully removed ${payload}!!!`);
      },
      [removeVideoFromFSandRedux.rejected]: (state, { rejectWithValue, error, payload }) => {
         state.isLoading = false;
         state.message = "";
         if (rejectWithValue || error) {
            console.error({ origin: "removeVideoFromFSandRedux.rejected", error, errorCode: error.code, errorMessage: error.message, rejectWithValue: rejectWithValue("rejectWithValue error while trying to delete " + payload), payload });
         } else {
            console.error({ origin: "removeVideoFromFSandRedux.rejected", message: `Something went wrong trying to delete ${payload}.`, payload });
         }
      }
   }
})

export const { addNewVideo, removeVideo, updateVideo } = allVideosSlice.actions;
export const allVideosSliceReducer = allVideosSlice.reducer;
export const videosReducer = state => state.allVideosSliceReducer;
export const allVideos = state => state.allVideosSliceReducer.allVideos;